<template>
    <div class="row mt-2 align-items-end">
        <div class="col-12" v-if="amountsDifferent">
            <div class="bg-danger-light rounded-8 p-3">
                <p class="text-danger mb-1">
                    Montant total de la facture : <b>{{ total }}{{ $symbolCurrency }}</b>
                </p>
                <p class="text-danger mb-0">
                    Différence :
                    <b>{{ isNaN(totalDifference) ? ' (veuillez entrer une valeur) ' : totalDifference }}{{ $symbolCurrency }}</b>
                </p>
            </div>
        </div>
        <div class="col-12" v-if="isSaved">
            <div class="bg-success-light rounded-pill px-3 py-2 mt-3">
                <span class="text-success">Les modifications ont bien été sauvegardées.</span>
            </div>
        </div>

        <div class="mt-3" v-for="(amount, index2) in currentAmounts" :key="index2">
            <label for="paymentMethod" class="form-label fw-bold"></label>
            <label class="form-label" for="">{{ amount.name }}</label>

            <div class="input-group rounded-24">
                <!--<span class="input-group-text text-white border-0" style="border-radius: 30px; margin-left: 4px; z-index: 4; height: 40px; width: 45px; position: absolute; margin-top: 5.5px; line-height: 21px; padding: 0px 16px; background-color:#C28540;">{{$symbolCurrency}}</span>-->
                <input
                    type="number"
                    min="0"
                    :name="'amount[' + amount.name + ']'"
                    placeholder="Montant"
                    class="form-control rounded-12 bg-transparent"
                    v-model="amount.amount"
                    @input="checkAmount()"
                    step="0.1"
                    :disabled="true"
                />
            </div>
        </div>

        <div class="col-12 col-md-6">
            <!--  <button class="btn btn-primary rounded-pill px-4"  @click="savePaymentMethods()" :disabled="amountsDifferent">
                Modifier les paiements
            </button>-->
            <!-- <button @click="deleteAllInput()" class="btn btn-danger" type="button"><i class="fa fa-trash"></i></button>-->
        </div>
    </div>
</template>

<script>
import axios from 'axios'

export default {
    props: ['paymentMethods', 'amounts', 'total', 'orderTotal'],
    data: () => ({
        currentAmounts: [],
        // Errors
        amountsDifferent: false,
        totalDifference: 0,
        // Messages
        isSaved: false,
        old: 0,
    }),
    methods: {
        checkAmount() {
            // console.log(this.total)
            // console.log(this.old)
            if (typeof this.total === 'undefined') {
                this.amountsDifferent = false
            } else {
                if (this.orderTotal - this.currentAmounts.reduce((acc, cur) => acc + parseFloat(cur.amount), 0) != 0) {
                    this.totalDifference = (
                        this.orderTotal - this.currentAmounts.reduce((acc, cur) => acc + parseFloat(cur.amount), 0)
                    ).toFixed(2)
                    this.amountsDifferent = true
                } else {
                    this.amountsDifferent = false
                }
            }
        },

        deleteAllInput() {
            this.currentAmounts = []
            this.amountsDifferent = false
        },

        savePaymentMethods() {
            this.amountsDifferent = true

            axios
                .post(this.$parent.$props.changePaymentMethodsRoute, {
                    orderId: this.$parent.$props.orderId,
                    amounts: this.currentAmounts,
                })
                .then((response) => {
                    this.isSaved = true
                    this.amountsDifferent = false
                    window.location.reload()
                })
                .catch((error) => {
                    //
                })
        },
        getoldMontant() {
            return this.orderTotal
        },
    },
    mounted() {
        this.old = this.getoldMontant()
    },
    watch: {
        paymentMethods: function (newValue) {
            this.currentAmounts = []

            //this.amountsDifferent = true
            this.checkAmount()
            newValue.forEach((element) => {
                if (this.amounts.length > 0) {
                    this.amounts.forEach((element2) => {
                        if (element2.paymentMethod == element.id) {
                            if (
                                this.currentAmounts.findIndex((amount) => amount.paymentMethod == element2.paymentMethod) == -1 ||
                                this.currentAmounts.findIndex((amount) => amount.idInvoice == element2.idInvoice) == -1
                            ) {
                                this.currentAmounts.push({
                                    paymentMethod: element.id,
                                    amount: element2.amount,
                                    name: element2.name,
                                    idInvoice: element2.idInvoice,
                                })
                            }
                        } else if (
                            !this.amounts.find((amount) => amount.paymentMethod == element.id) &&
                            this.currentAmounts.findIndex((amount) => amount.paymentMethod == element.id) == -1
                        ) {
                            this.currentAmounts.push({
                                paymentMethod: element.id,
                                amount: 0,
                                name: element.name,
                                idInvoice: 0,
                            })

                            this.amountsDifferent = true
                        }
                    })
                } else {
                    this.currentAmounts.push({
                        paymentMethod: element.id,
                        amount: 0,
                        name: element.name,
                        idInvoice: 0,
                    })
                    this.amountsDifferent = true
                }
            })
            this.total = this.currentAmounts.reduce((acc, cur) => acc + parseInt(cur.amount), 0)
        },
        currentAmounts: function (newValue) {
            if (!this.total) {
                this.total = this.old
            } else {
                this.total = this.amounts.reduce((acc, cur) => acc + cur.amount, 0)
            }
        },
    },
}
</script>

<style scoped>
.v-select.vs--multiple.vs--searchable.rounded-pill .vs__selected,
.v-select.vs--multiple.vs--searchable.rounded-pill .vs__dropdown-toggle {
    border-radius: 50rem !important;
}
</style>
